<div class="bg-white rounded-lg shadow-md" data-cy="dashboard-medical-search">
  <button
    type="button"
    class="w-full flex flex-wrap items-center gap-3 px-6 py-4 text-left cursor-pointer bg-transparent border-0"
    [attr.aria-expanded]="open"
    (click)="toggle()"
  >
    <i class="pi pi-search text-[var(--p-primary-600)]"></i>
    <span class="font-bold text-[var(--p-primary-600)]">{{ 'dashboard.medicalSearch.headline' | transloco }}</span>
    <span class="text-sm text-gray-500">{{ 'dashboard.medicalSearch.hint' | transloco }}</span>
    <span class="ml-auto flex items-center gap-2 text-sm font-semibold text-[var(--p-primary-600)]">
      {{ (open ? 'dashboard.medicalSearch.collapse' : 'dashboard.medicalSearch.expand') | transloco }}
      <i [class]="open ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"></i>
    </span>
  </button>

  @if (open) {
    <div class="px-6 pb-6 pt-1 border-t border-gray-200">
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-4">
        <div class="flex flex-col gap-1">
          <label class="text-sm text-gray-700" for="medicalFinding">{{ 'dashboard.medicalSearch.fields.medicalFinding' | transloco }}</label>
          <input id="medicalFinding" pInputText class="w-full" [(ngModel)]="filters.medicalFinding"
                 [placeholder]="'dashboard.medicalSearch.placeholders.medicalFinding' | transloco" />
        </div>

        <div class="flex flex-col gap-1">
          <label class="text-sm text-gray-700" for="veterinarian">{{ 'dashboard.medicalSearch.fields.veterinarian' | transloco }}</label>
          <input id="veterinarian" pInputText class="w-full" [(ngModel)]="filters.veterinarian"
                 [placeholder]="'dashboard.medicalSearch.placeholders.veterinarian' | transloco" />
        </div>

        <div class="flex flex-col gap-1">
          <label class="text-sm text-gray-700" for="medicalDate">{{ 'dashboard.medicalSearch.fields.medicalDate' | transloco }}</label>
          <input id="medicalDate" pInputText class="w-full" [(ngModel)]="filters.medicalDate"
                 placeholder="2026-08" />
        </div>

        <div class="flex flex-col gap-1">
          <label class="text-sm text-gray-700" for="medicalCondition">{{ 'dashboard.medicalSearch.fields.medicalCondition' | transloco }}</label>
          <input id="medicalCondition" pInputText class="w-full" [(ngModel)]="filters.medicalCondition"
                 [placeholder]="'dashboard.medicalSearch.placeholders.medicalCondition' | transloco" />
        </div>

        <div class="flex flex-col gap-1">
          <label class="text-sm text-gray-700" for="treatmentType">{{ 'dashboard.medicalSearch.fields.treatmentType' | transloco }}</label>
          <p-select
            id="treatmentType"
            class="w-full"
            [options]="treatmentTypeOptions"
            [filter]="true"
            [showClear]="true"
            [(ngModel)]="filters.treatmentType"
            optionLabel="name"
            optionValue="value"
            [placeholder]="'dashboard.medicalSearch.placeholders.treatmentType' | transloco"
          />
        </div>

        <div class="flex flex-col gap-1">
          <label class="text-sm text-gray-700" for="treatmentPreparation">{{ 'dashboard.medicalSearch.fields.treatmentPreparation' | transloco }}</label>
          <input id="treatmentPreparation" pInputText class="w-full" [(ngModel)]="filters.treatmentPreparation"
                 [placeholder]="'dashboard.medicalSearch.placeholders.treatmentPreparation' | transloco" />
        </div>

        <div class="flex flex-col gap-1">
          <label class="text-sm text-gray-700" for="treatmentDueAt">{{ 'dashboard.medicalSearch.fields.treatmentDueAt' | transloco }}</label>
          <input id="treatmentDueAt" pInputText class="w-full" [(ngModel)]="filters.treatmentDueAt"
                 placeholder="&lt;2026-10-01" />
        </div>

        <div class="flex flex-col gap-1">
          <label class="text-sm text-gray-700" for="quarantineUntil">{{ 'dashboard.medicalSearch.fields.quarantineUntil' | transloco }}</label>
          <input id="quarantineUntil" pInputText class="w-full" [(ngModel)]="filters.quarantineUntil"
                 placeholder="2026-09-01..2026-09-30" />
        </div>
      </div>

      <div class="flex flex-wrap items-center gap-3 mt-4">
        <span class="text-xs text-gray-500">{{ 'dashboard.medicalSearch.dateHint' | transloco }}</span>
        <div class="ml-auto flex items-center gap-2">
          <p-button
            [label]="'dashboard.medicalSearch.reset' | transloco"
            [outlined]="true"
            severity="secondary"
            icon="pi pi-refresh"
            (onClick)="reset()"
          />
          <p-button
            [label]="'dashboard.medicalSearch.submit' | transloco"
            icon="pi pi-search"
            [disabled]="!hasValues"
            (onClick)="apply()"
          />
        </div>
      </div>
    </div>
  }
</div>
